import TrackingService from "../tracking_service";
import mixpanel from "mixpanel-browser";

class TrackingServiceImpl extends TrackingService {
    static #instance = null;

    constructor() {
        if (TrackingServiceImpl.#instance) {
            return TrackingServiceImpl.#instance;
        }
        super();
        TrackingServiceImpl.#instance = this;
        this.token = process.env.REACT_APP_MIXPANEL_TOKEN;
        mixpanel.init(this.token, {
            debug: true,
            // autocapture: {
            //     pageview: "full-url",
            //     click: true,
            //     input: true,
            //     scroll: true,
            //     submit: true,
            //     capture_text_content: false,
            // },
            // capture_pageview: true,
            // capture_pageleave: true,
        });
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        this.os = 'unknown';

        if (/Mac/i.test(platform)) this.os = 'macOS';
        if (/Win/i.test(platform)) this.os = 'Windows';
        if (/Linux/i.test(platform)) this.os = 'Linux';
        if (/Android/i.test(userAgent)) this.os = 'Android';
        if (/iPhone|iPad|iPod/i.test(userAgent)) this.os = 'iOS';

        this.ip = 0;

        try {
            fetch('https://api.ipify.org?format=json')
                .then(res => res.json())
                .then(data => this.ip = data.ip)
                .catch(err => console.error('Failed to get IP address:', err));
        } catch (e) {
            
        }
    }

    trackEvent(eventName, properties) {
        if(properties.userId) {
            properties.distinct_id = properties.userId;
        }
        properties.$os = this.os;
        properties.$ip = this.ip;
        console.log("Tracking event:", eventName, '; Properties:', properties);
        try {
            mixpanel.track(eventName, properties);
        } catch (e) {
            console.log("Error tracking event:", e);
        }
    }

    identify(userId, properties) {
        console.log("Identifying user:", userId, properties);
        try {
            if (userId) {
                properties.distinct_id = userId;
            }
            properties.os = this.os;
            properties.$ip = this.ip;
            mixpanel.identify(userId);
            mixpanel.people.set(properties);
        } catch (e) {
            console.log("Error identifying user:", e);
        }
    }

    identifyOnce(userId, properties = {}) {
        console.log("Identifying user once:", userId, properties);
        try {
            if (userId) {
                properties.distinct_id = userId;
            }
            properties.os = this.os;
            properties.$ip = this.ip;
            mixpanel.identify(userId);
            mixpanel.people.set(properties);
        } catch (e) {
            console.log("Error identifying user once:", e);
        }
    }

    setUserProperties(distinctId, properties = {}) {
        console.log("Setting user properties:", properties);
        try {
            if (properties.userId) {
                properties.distinct_id = properties.userId;
            }
            properties.os = this.os;
            properties.$ip = this.ip;
            mixpanel.people.set(distinctId, properties);
        } catch (e) {
            console.log("Error setting user properties:", e);
        }
    }
}

export default TrackingServiceImpl;